import MediaViewPreference from '../models/MediaViewPreference';

class ViewSelectorButton extends Backbone.View {

    constructor() {
        super(...arguments);

        if (this.constructor === ViewSelectorButton) {
            throw new TypeError('ViewSelectorButton cannot be instantiated directly');
        }

        this.listenTo(this.model, 'change', this.render);

        this.$el.on('click keypress', (e) => {
            if (this.isSelectEvent(e)){
                this.select();
                return false;
            }
            return true;
        });
    }

    select() {
        this.model.set({ view: this.view });
    }

    isSelectEvent = (e) => (e.type === 'click' || e.which === 13 || e.which === 32) && (e.preventDefault() || true);

    render() {
        if (!this.view || !this.template){
            throw new Error('this.view and this.template are required');
        }

        this.$el.html(this.template({
            selected: this.model.get('view') === this.view
        }));
    }
}

class GridViewSelectorButton extends ViewSelectorButton{
    constructor(){
        super(...arguments);
        this.template = ({ selected }) =>
            `<a tabindex="0" class="view-as-grid" aria-label="${html('results.viewInGrid')}" role="button" style="display: inline;">
                    <i class="icon-grid ${!selected && 'gray'}" aria-hidden="true"></i>
                </a>`;
        this.view = MediaViewPreference.options.grid;
    }


}

class ListViewSelectorButton extends ViewSelectorButton {
    constructor() {
        super(...arguments);
        this.template = ({ selected }) =>
            `<a tabindex="0" class="view-as-list" aria-label="${html('results.viewInList')}" role="button" style="display: inline;">
                        <i class="icon-list ${!selected && 'gray'}" aria-hidden="true"></i>
                    </a>`;
        this.view = MediaViewPreference.options.list;
    }
}


class TitleCollectionViewSelector extends Backbone.View {

    template = () => `
        <div style="position: relative">
            <div class="GridViewButton"></div>
            <div class="ListViewButton"></div>
        </div>`;

    constructor(options) {
        super(options);

        this.model = new MediaViewPreference();

        this.$el.prepend(this.template());

        this.listViewButton = new ListViewSelectorButton(
            {
                el: this.$('.ListViewButton'),
                model: this.model
            }).render();
        this.gridViewButton = new GridViewSelectorButton(
            {   el: this.$('.GridViewButton'),
                model: this.model
            }).render();

    }
}

export default TitleCollectionViewSelector;
